import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { get, post } from "../../services/api";
import { toast } from "react-toastify";
import NotificationEventTypes from "../../constants/notificationEventsEnum";

function ExitInterviewRemarksModal({
  onClose,
  firstRegistrationId,
  refreshOnSubmitSuccess,
  interviewData,
}) {
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");
  const roleId = localStorage.getItem("roleId");
  const isParent = ["9", "10"].includes(roleId);
  const isSectionHead = ["30"].includes(roleId);
  const isCampusOfficer = ["3"].includes(roleId);

  const [isFormDisabled, setIsFormDisabled] = useState(false);

  const {
    register,
    formState: { errors, isSubmitting },
    handleSubmit,
    reset,
  } = useForm({
    defaultValues: {
      status: "",
      remarks: "",
    },
  });

  useEffect(() => {
    const fetchInterviewRemarks = async () => {
      try {
        const response = await get(
          `Withdrawal/GetWithdrawalInterviewRemarks?UserId=${userId}&WithdrawalId=${firstRegistrationId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response?.id && response.remarks) {
          setIsFormDisabled(true);
          reset({
            status: response.status || "",
            remarks: response.remarks || "",
          });
        } else {
          setIsFormDisabled(false);
          reset({
            status: "",
            remarks: "",
          });
        }
      } catch (error) {
        console.error("Error fetching interview remarks:", error);
        setIsFormDisabled(false);
        reset({
          status: "",
          remarks: "",
        });
      }
    };

    if (firstRegistrationId && userId) {
      fetchInterviewRemarks();
    }
  }, [firstRegistrationId, userId, reset]);

  const saveInterviewRemarks = async (data) => {
    const sectionHeadAlertManagerParams = {
      FormId: 59,
      NotificationEventTypeIds: NotificationEventTypes.FORWARD.toString(),
    };

    const campusOfficerAlertManagerParams = {
      FormId: 59,
      NotificationEventTypeIds: NotificationEventTypes.ADD.toString(),
    };

    const formData = {
      studentFirstRegistrationId: interviewData?.studentFirstRegistrationId,
      withdrawalId: firstRegistrationId,
      userId: userId,
      status: isParent ? "Approved" : data.status,
      remarks: data.remarks,
      createdBy: userId,
      updatedBy: userId,
      ...(isSectionHead && sectionHeadAlertManagerParams),
      ...(isCampusOfficer && campusOfficerAlertManagerParams),
    };

    console.log(formData);
    // return;

    try {
      const response = await post(
        "Withdrawal/UpdateWithdrawalInterviewStatus",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.isSuccess) {
        toast.success("Interview remarks saved successfully!");
        onClose();
        refreshOnSubmitSuccess();
      } else {
        toast.error("Failed to save interview remarks.");
      }
    } catch (error) {
      console.error("Error saving interview remarks:", error);
      toast.error("An error occurred while saving the interview remarks.");
    }
  };

  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{ display: "block" }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="mb-0">Interview Remarks</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <form
                className="row g-3 new-form-style"
                onSubmit={handleSubmit(saveInterviewRemarks)}
              >
                {!isParent && (
                  <div className="col-md-12">
                    <label className="form-label form-label-new">
                      Status<span className="text-danger fs-9">*</span>
                    </label>
                    <select
                      {...register("status", {
                        required: "This field is required.",
                      })}
                      className="form-select"
                      disabled={isFormDisabled}
                    >
                      <option value="">Select</option>
                      <option value="Approved">Approve</option>
                      {/* <option value="Rejected">Reject</option>
                      <option value="Pending">Pending</option> */}
                    </select>
                    {errors.status && (
                      <small className="text-danger">
                        {errors.status.message}
                      </small>
                    )}
                  </div>
                )}
                <div className="col-md-12">
                  <label className="form-label form-label-new">
                    Remarks<span className="text-danger fs-9">*</span>
                  </label>
                  <textarea
                    {...register("remarks", {
                      required: "This field is required.",
                    })}
                    className="form-control"
                    disabled={isFormDisabled}
                  ></textarea>
                  {errors.remarks && (
                    <small className="text-danger">
                      {errors.remarks.message}
                    </small>
                  )}
                </div>
                <div className="d-flex gap-2 justify-content-end">
                  <button
                    className="btn btn-primary btn-sm"
                    type="submit"
                    disabled={isSubmitting || isFormDisabled}
                  >
                    {isSubmitting ? (
                      <span
                        className="spinner-border spinner-custom-size me-1"
                        aria-hidden="true"
                      ></span>
                    ) : null}
                    <span role="status">Save</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}

export default ExitInterviewRemarksModal;
